module.exports = __webpack_public_path__ + "img/xsz-back-bg.0c7065b5.png";